import { a as MICRO_APP_TAG_NAME, c as SUITE_APP_RETURN_EVENT, i as APP_FETCH_OPTIONS, l as SuiteAppType, n as isError, o as SUITE_APP_CALL_EVENT, r as parseCallEvent, s as SUITE_APP_EVENT_PREFIX, t as composeCallPath } from "../base-CO-oOWt_.js";
import { EventBase } from "@peerup/utils";
//#region src/adapter/adapter.ts
/**
* 子应用接入suite的适配器
*/
var SuiteAdapter = class SuiteAdapter extends EventBase {
	microApp;
	config;
	/**
	* 是否是微前端环境
	*/
	static isMicroApp = () => {
		return !!window.__MICRO_APP_ENVIRONMENT__;
	};
	/** 当前所在的 Suite微应用实例 */
	static current = null;
	/**
	* 当前应用名称，全局只有一份
	*/
	static appName = window.__MICRO_APP_NAME__ || "";
	/**
	* 获取真实document（即主应用document）, 如果没有则使用当前document
	*/
	static document = window.rawDocument || document;
	/**
	* 获取真实window（即主应用window）, 如果没有则使用当前window
	*/
	static window = window.rawWindow || window;
	/**
	* 获取全局数据
	*/
	static getGlobalData = () => {
		if (!SuiteAdapter.isMicroApp()) return void 0;
		return window.microApp?.getGlobalData();
	};
	constructor(config) {
		super();
		SuiteAdapter.current = this;
		this.microApp = window.microApp;
		this.config = config;
		if (!window.__MICRO_APP_ENVIRONMENT__) console.error("当前环境不是微前端环境");
	}
	eventCallback = (data) => {
		if (!data.event.startsWith("Event:")) return;
		if (data.source === SuiteAdapter.appName && data.from === "child") return;
		if (data.source !== SuiteAdapter.appName) return;
		this.emit(data.event, data.data);
	};
	mount = () => {
		this.config.mount();
		this.microApp?.addGlobalDataListener(this.eventCallback);
		if (window.__MICRO_APP_ENVIRONMENT__) this.dispatch("mount", {});
	};
	unmount = () => {
		this.clearEvents();
		this.microApp?.clearGlobalDataListener();
		this.config.unmount();
		if (window.__MICRO_APP_ENVIRONMENT__) this.dispatch("unmount", {});
	};
	getState = () => {
		return this.microApp?.getData(true);
	};
	/**
	* 自定义方法
	* @param msg 自定义方法
	* @returns
	*/
	logger = (msg) => {
		return new Promise((resolve) => {
			setTimeout(() => {
				this.microApp?.forceDispatch({ msg }, resolve);
			}, 0);
		});
	};
	/** 启动 */
	bootstrap = () => {
		if (window.__MICRO_APP_ENVIRONMENT__) {
			window.mount = this.mount;
			window.unmount = this.unmount;
		} else this.mount();
	};
	/**
	* 向父应用触发事件
	*/
	dispatch = (event, data) => {
		this.microApp?.forceSetGlobalData({
			event: `${SUITE_APP_EVENT_PREFIX}${event}`,
			source: SuiteAdapter.appName,
			from: "child",
			data
		}, (_res) => {});
	};
	/**
	* 监听父应用事件
	*/
	listen = (event, callback) => {
		return this.on(`${SUITE_APP_EVENT_PREFIX}${event}`, callback);
	};
};
/**
* 创建 Suite 微应用适配器，如果已经存在则返回当前实例(单例模式)
* @param opts 适配器配置
* @returns 适配器实例
*/
const createSuiteAdapter = (opts) => {
	if (SuiteAdapter.current) return SuiteAdapter.current;
	return new SuiteAdapter(opts);
};
//#endregion
export { APP_FETCH_OPTIONS, MICRO_APP_TAG_NAME, SUITE_APP_CALL_EVENT, SUITE_APP_EVENT_PREFIX, SUITE_APP_RETURN_EVENT, SuiteAdapter, SuiteAppType, composeCallPath, createSuiteAdapter, isError, parseCallEvent };
